import { render, staticRenderFns } from "./DyDLanding.vue?vue&type=template&id=513d66f7"
import script from "./DyDLanding.vue?vue&type=script&lang=js"
export * from "./DyDLanding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports